import { useForm } from "react-hook-form";
import { PasswordInput, Switch, Text, TextInput } from "@mantine/core";
import { MyButton } from "../../UI/my-button/MyButton";
import { IconUserPlus } from "@tabler/icons";
import { useColors } from "../../../hooks/colors/useColors";
import { PasswordValidationInput } from "../../UI/my-input/PasswordValidationInput";
import { useRegistration } from "./useRegistration";
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";

type InputProps = {
  closeModal?: () => void;
  autoSignIn?: boolean;
};

const MyPhone = dynamic(
  () => import("./../../UI/phone/MyPhone").then((mod) => mod.MyPhone),
  {
    ssr: false,
  }
);

export function RegistrationForm(props: InputProps) {
  const { closeModal, autoSignIn } = props;
  const { colors } = useColors();
  const { error, processing, registerUser } = useRegistration();
  const { t } = useTranslation("common");

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      email: "",
      password: "",
      matchingPassword: "",
      acceptTerms: false,
      phone: "",
    },
  });

  return (
    <form
      onSubmit={handleSubmit(async (data) => {
        const finalizeFunction = closeModal ? closeModal : () => {};
        await registerUser(data, errors, finalizeFunction, autoSignIn);
      })}
    >
      <TextInput
        error={errors.name?.message}
        withAsterisk
        className="mb-4"
        type="text"
        label={t("login.name")}
        // @ts-ignore
        placeholder={t("login.name")}
        {...register("name", {
          minLength: {
            value: 3,
            message: t("login.nameError"),
          },
          maxLength: {
            value: 99,
            message: t("login.nameError"),
          },
        })}
      />
      <TextInput
        error={errors.email?.message}
        withAsterisk
        className="mb-4"
        type="email"
        label={t("login.email")}
        placeholder="your@email.com"
        {...register("email", {
          pattern: {
            value: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
            message: t("login.invalidEmail"),
          },
        })}
      />
      <PasswordValidationInput
        watch={watch}
        // @ts-ignore
        placeholder={t("user.password")}
        errors={errors.password?.message}
        register={register}
        field="password"
      />
      <PasswordInput
        error={errors.matchingPassword?.message}
        className="mt-4"
        withAsterisk
        label={t("user.repeatPassword")}
        {...register("matchingPassword", {
          required: true,
          // @ts-ignore
          validate: (value: string) => {
            if (watch("password") !== value) {
              return t("login.invalidMatchingPassword");
            }
          },
        })}
      />

      <MyPhone
        className="mt-4"
        withBorder
        hideIcon
        required
        // @ts-ignore
        label={t("phone")}
        field="phone"
        setFormValue={setValue}
        // value={getValues().phone}
        // stringValue
        errors={errors.phone?.message}
      />
      <Switch
        error={errors.acceptTerms?.message}
        className="mt-4"
        label={t("login.acceptTerms")}
        {...register("acceptTerms", {
          // @ts-ignore
          required: t("login.acceptTermsError"),
        })}
      />
      {error.length > 1 && (
        <Text className="mt-4" color={colors.danger}>
          {error}
        </Text>
      )}

      <MyButton
        fullWidth
        disabled={processing}
        loading={processing}
        icon={<IconUserPlus />}
        submit
        className="w-full mt-4"
        title={t("login.register")}
        textColor="white"
        color={colors.primary}
        onClick={() => {}}
      />
    </form>
  );
}
